module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1sX90"))).then(() => parcelRequire('1iHdE'));